import HelpGuide from '@intercom/embercom-composer/components/help-guide';
export default HelpGuide;
